import React from "react";
import { Container } from "./styles";

const ContentBox = ({ children }) => {
  return <Container>{children}</Container>;
};

export default ContentBox;
